<template>
	<div class="tokens-select p-1 py-4">
		<div class="token-row" :class="{'disabled noselect': disabled}">
			<div class="col-12 text-end">
				<div class="flex gap-4 items-center input-container animate__animated animate__fadeIn">
					<TokenPicker :disabled="tokenLocked" class="picker" :token="token" @tokenChange="onTokenChange" :key="token?.address.toString()"></TokenPicker>
					<div>
						<input class="form-control form-control-lg form-control-compact text-end fw-bold !text-4xl max-sm:!text-2xl" placeholder="-" :value="inputValue.toLocaleString()" v-if="disabled">
						<input @focus="onFocus" v-else v-model.number="inputValue" @input="onInput" ref="inp" inputmode="decimal" autocomplete="off"
								class="form-control form-control-lg form-control-compact text-end fw-bold !text-4xl max-sm:!text-2xl"
								placeholder="0.0">
						<p class="mb-0 small balance">
							<TokenPrice :max-digits="2" :amount="inputValue" :token="publicKey"></TokenPrice>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TokenPicker from "@/components/token/TokenPicker.vue";
import { web3 } from "@project-serum/anchor";
import TokenPrice from "@/components/common/TokenPrice.vue";

export default {
	name: "TokenSelect",
	components: { TokenPrice, TokenPicker },
	props: {
		id: {
			type: String,
			required: true,
		},
		token: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
		tokenLocked: {
			type: Boolean,
			default() {
				return false;
			},
		},
		amount: {
			type: Number,
		},
	},
	data() {
		return {
			fmt: new Intl.NumberFormat(),
			numRegex: new RegExp(/^\d*\.?\d*$/),
			lastValid: 0,
		};
	},
	computed: {
		inputValue: {
			get() {
				const value =
					this.$store.state.swap[`token${this.id}Amount`] /
					Math.pow(10, this.token.decimals);

				return value === 0 ? "" : value;
			},
			set(val) {
				this.$store.commit(
					`swap/setToken${this.id}Amount`,
					val * Math.pow(10, this.token.decimals)
				);
			},
		},

		publicKey: function () {
			if (!this.token?.address) return web3.PublicKey.default;

			return new web3.PublicKey(this.token.address);
		},
	},
	methods: {
		onFocus: function (e) {
			e.target.select();
		},

		onInput: function () {
			const inpFull =
				Number(this.inputValue) * Math.pow(10, this.token.decimals);
			if (this.numRegex.test(this.$refs.inp.value)) {
				this.lastValid = this.$refs.inp.value;
				this.notify(inpFull);
			} else {
				console.log("Reset", this.lastValid);
				this.$refs.inp.value = this.lastValid;
				this.inputValue = this.lastValid;
			}
		},
		onTokenChange: function (token) {
			this.$emit("tokenChange", token);
		},
		notify: function (num) {
			if (this.disabled) return;
			this.$emit("input", num);
		},
	},
};
</script>

<style scoped>
.token-row {
	display: flex;
	flex-direction: row;
	align-content: space-around;
	align-items: center;
	flex-wrap: wrap;
}

.input-container {
	position: relative;
}

.tokens-select {
	background: var(--bs-dark);
	border-radius: 6px;
}

.form-control {
	border: unset;
}

.form-control-compact {
	min-height: unset;
	padding: 0;
	line-height: 1;
	/*font-size: 1.75rem;*/
	font-size: 3rem;
	display: inline-block;
}

.form-control-compact:active,
.form-control-compact:focus {
	background: transparent;
}
</style>
